import PlayedGame from "../assets/icons/played_games_1x.webp";
import PlayedGame2x from "../assets/icons/played_games_2x.webp";
import PlayedGame3x from "../assets/icons/played_games_3x.webp";
import TotalTime from "../assets/icons/total_time_1x.webp";
import TotalTime2x from "../assets/icons/total_time_2x.webp";
import TotalTime3x from "../assets/icons/total_time_3x.webp";
import TotalGem from "../assets/icons/cup_1x.webp";
import TotalGem2x from "../assets/icons/cup_2x.webp";
import TotalGem3x from "../assets/icons/cup_3x.webp";

type StatKey = "playedGames" | "totalTime" | "totalGems";

export const STAT_DEFS: Record<
  StatKey,
  {
    label: string;
    icon: { src1x: string; src2x: string; src3x: string };
    showGem?: boolean;
  }
> = {
  playedGames: {
    label: "played_games",
    icon: { src1x: PlayedGame, src2x: PlayedGame2x, src3x: PlayedGame3x },
  },
  totalTime: {
    label: "total_played_time",
    icon: { src1x: TotalTime, src2x: TotalTime2x, src3x: TotalTime3x },
  },
  totalGems: {
    label: "total_gems_won",
    icon: { src1x: TotalGem, src2x: TotalGem2x, src3x: TotalGem3x },
    showGem: true,
  },
};
